import { render } from "./InstructionsViewComponent.vue?vue&type=template&id=718aebfc&scoped=true"
const script = {}

import "./InstructionsViewComponent.vue?vue&type=style&index=0&id=718aebfc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718aebfc"]])

export default __exports__